import React from 'react';
import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import {FileUploadData} from '../../TypeScript/interfaces';

//Context 
//contains data(uploadData) and function to change the data (setUploadData)
export type UploadData = {
  fileUploadData: Partial<FileUploadData>;  
  setUploadData: (fileUploadData:FileUploadData) => void;
};

//Here is created the initial context
//The context can be either NULL or UploadData see the definotion of the type above
const FileUploadInfoContext = createContext<UploadData | null>(null);

//This is called when the context is used. 
//There is the data itself and function to amend the data
//see e.g. fileUploadInformation.tsx
export const useFileUploadInfoData = () => {
  const context = useContext(FileUploadInfoContext);

  if (!context) {
    throw new Error('useFileUploadInfoData must be used within FileUploadInfoProvider');
  }  
  return context;
};

type ProviderProps = {
  children: ReactNode;
};  

const FileUploadInfoProvider: React.FC<ProviderProps> = (providerProps) => {
  const {children} = providerProps;
  const [contextData, setContextData] = useState<UploadData['fileUploadData']>({});    

  const handleDataChange = useCallback(
    (setUploadData: FileUploadData) => {
      setContextData(setUploadData);
    },
    [],
  );
    
  return (
      <FileUploadInfoContext.Provider
        value={{
          fileUploadData: contextData,
          setUploadData: handleDataChange,
        }}
      >
        {children}
      </FileUploadInfoContext.Provider>
   );
};
  
export default FileUploadInfoProvider;
  